import { Icon } from 'Icon';
import { IconButton } from 'IconButton';

import { SimpleModalTitleStyled } from './SimpleModalTitle.styled';

export type ModalTitleStyledProps = {
  title: string;
  onClose: () => void;
};

export function SimpleModalTitle({ title, onClose }: ModalTitleStyledProps) {
  return (
    <SimpleModalTitleStyled id="simple-modal-title">
      {title}
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: '32px',
          top: '34px',
          color: (theme) => theme.palette.blueGrey['A400'],
        }}
      >
        <Icon icon="closeLight" size={24} />
      </IconButton>
    </SimpleModalTitleStyled>
  );
}
